export const RENDER_COLOR = "#F2C57C";
